import { render, staticRenderFns } from "./OVEDetailView.vue?vue&type=template&id=16f8f4c9&scoped=true&lang=pug"
import script from "./OVEDetailView.vue?vue&type=script&lang=js"
export * from "./OVEDetailView.vue?vue&type=script&lang=js"
import style0 from "./OVEDetailView.vue?vue&type=style&index=0&id=16f8f4c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f8f4c9",
  null
  
)

export default component.exports